'use client';
import React, { createContext, useContext, useState } from 'react';
import { ProfileExpanded } from '~/types';

interface ProfileContextType {
  profile: ProfileExpanded | null;
  setProfile: (profile: ProfileExpanded) => void;
}

export const ProfileContext = createContext<ProfileContextType | undefined>(
  undefined,
);

export const ProfileProvider = ({
  initialProfile,
  children,
}: {
  initialProfile?: ProfileExpanded | null;
  children: React.ReactNode;
}) => {
  const [profile, setProfile] = useState<ProfileExpanded | null>(
    initialProfile || null,
  );

  return (
    <ProfileContext.Provider
      value={{
        profile,
        setProfile,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => {
  const context = useContext(ProfileContext);

  if (!context) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }

  return context;
};
